import { useState, useEffect } from 'react';
import { Common } from '@stockbit/ui';
import { useDispatch, useSelector } from 'react-redux';
import { Relative } from 'features/onboarding/OnBoardingLayout/styled';

// Store company
import {
  effects as companyEffects,
  selectors as companySelectors,
} from 'lib/entities/company';
import { renderStockSuggestions } from './options';

const { Input, Iconmoon, Autocomplete } = Common;

interface SearchProps {
  searchValue: string;
  handleSelectedValueStock: (params: any) => void;
  isClickAlertLog: boolean;
  isEdit: boolean;
}

function Search({
  searchValue,
  handleSelectedValueStock,
  isClickAlertLog,
  isEdit,
}: SearchProps) {
  const [timeInterval, setTimeInterval] = useState<any>(0);
  const [value, setValue] = useState('');
  const {
    search: { data: dataSearch },
  } = useSelector(companySelectors);

  useEffect(() => {
    if (searchValue) {
      setValue(searchValue);
    }
    return () => {
      setValue('');
    };
  }, [searchValue]);

  // handle actions
  const dispatch = useDispatch();

  const handleSearchCompany = (val) => {
    if (val.length > 1) {
      if (timeInterval) {
        clearTimeout(timeInterval);
      }

      setTimeInterval(
        setTimeout(() => {
          // @ts-ignore
          dispatch(companyEffects.getSearchCompany(val));
        }, 1500),
      );
    }
  };

  const handleSelectCompany = (val) => {
    handleSelectedValueStock(val);

    // dispatch search company with stock name
    dispatch(companyEffects.getSearchCompany(val));
  };

  const handleChange = (val) => {
    setValue(val);
  };

  const options = renderStockSuggestions(dataSearch);

  return (
    <Relative>
      <Autocomplete
        options={options}
        width="100%"
        onSelect={handleSelectCompany}
        onSearch={handleSearchCompany}
        onChange={handleChange}
        mb="8px"
        getPopupContainer={(trigger) => trigger.parentElement}
        value={value}
        disabled={isClickAlertLog || isEdit}
      >
        <Input
          placeholder="Type stocks here .."
          height="36px"
          width="100%"
        />
      </Autocomplete>
    </Relative>
  );
}

Search.defaultProps = {
  searchValue: '',
  handleSelectedValueStock: () => {},
  isClickAlertLog: false,
};

export default Search;
